import { generateId } from "./generate-id"

export function processContentWithIds(content: string): string {
  return content.replace(/<(h[1-3])>(.*?)<\/\1>/g, (_, tag, text) => {
    const id = generateId(text);
    return `<${tag} id="${id}">${text}</${tag}>`;
  });
}

// export function processContentWithIds(content: string): string {
//   // Create a temporary DOM parser
//   const parser = new DOMParser()
//   const doc = parser.parseFromString(content, "text/html")

//   // Find all headings
//   const headings = doc.querySelectorAll("h1, h2, h3")

//   // Add IDs to each heading
//   headings.forEach((heading) => {
//     const text = heading.textContent || ""
//     const id = generateId(text)
//     heading.id = id
//   })

//   // Return the processed HTML
//   return doc.body.innerHTML
// }
